module.exports = __webpack_public_path__ + "static/media/tela-passo-03.38d9b845.jpg";